// Copied from the VueUse lib
import {
    getCurrentScope,
    onScopeDispose,
} from '@vue/composition-api';

export function tryOnScopeDispose(fn: () => void) {
    if (getCurrentScope()) {
        onScopeDispose(fn);

        return true;
    }

    return false;
}
